"use client";

import { cn } from "@/lib/utils";

const ICON_SIZE = 32;

interface MediaIconProps {
  children: React.ReactNode;
  redirect: () => void;
}

export const MediaIcon = ({ redirect, children }: MediaIconProps) => {
  return (
    <button
      type="button"
      onClick={redirect}
      className={cn(
        "group inline-flex items-center justify-center rounded-full bg-transparent transition-colors",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cede-primary/40",
        "text-cede-primary cursor-pointer",
      )}
      style={{
        width: ICON_SIZE,
        height: ICON_SIZE,
      }}
    >
      <svg
        viewBox="0 0 24 24"
        fill="currentColor"
        className="h-10 w-10 text-cede-primary transition-colors group-hover:text-cede-primary-dark"
      >
        {children}
      </svg>
    </button>
  );
};
